import { Injectable } from '@angular/core';

export enum LogLevel {
  Log = 'LOG',
  Dir = 'DIR',
  Trace = 'TRACE',
  Info = 'INFO',
  Debug = 'DEBUG',
  Warning = 'WARNING',
  Error = 'ERROR',
  Fatal = 'FATAL'
}

/* istanbul ignore next */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor() { }
  public console(message: string, level: LogLevel, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      switch (level) {
        case LogLevel.Log:
          this.log(message, format, optionalParams);
          break;
        case LogLevel.Dir:
          this.dir(message, format, optionalParams);
          break;
        case LogLevel.Trace:
          this.trace(level + ': ' + message, format, optionalParams);
          break;
        case LogLevel.Info:
          this.info(level + ': ' + message, format, optionalParams);
          break;
        case LogLevel.Debug:
          this.debug(level + ': ' + message, format, optionalParams);
          break;
        case LogLevel.Warning:
          this.warn(level + ': ' + message, format, optionalParams);
          break;
        case LogLevel.Error:
        case LogLevel.Fatal:
          this.error(level + ': ' + message, format, optionalParams);
          break;
        default:
          break;
      }
    }
  }

  public log(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.log(message, format, optionalParams);
      } else {
        console.log(message, format);
      }
    }
  }

  public dir(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.dir(message, optionalParams);
      } else {
        console.dir(message);
      }
    }
  }

  public trace(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.trace(message, format, optionalParams);
      } else {
        console.trace(message, format);
      }
    }
  }

  public info(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.info(message, format, optionalParams);
      } else {
        console.info(message, format);
      }
    }
  }

  public debug(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.debug(message, format, optionalParams);
      } else {
        console.debug(message, format);
      }
    }
  }

  public warn(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.warn(message, format, optionalParams);
      } else {
        console.warn(message, format);
      }
    }
  }

  public error(message: string, format?: string, optionalParams?: any[]): void {
    if ((<any>window).ConsolLog) {
      if (optionalParams && optionalParams.length > 0) {
        console.error(message, format, optionalParams);
      } else {
        console.error(message, format);
      }
    }
  }
}
